export default __webpack_public_path__ + "static/media/013-mosasaurus.7bd6f0ae.svg";